export const ELEMENT_HEIGHT = 32;
export const PADDING = 4;
export const TICK_LABEL_WIDTH = 60;
export const GRAPH_CONTENT_SIZE = 246;
